<style lang="sass" scoped>
::v-deep .el-select__tags
  max-width: 90% !important
.cityClass
  ::v-deep .el-select
    width: 190px !important
  ::v-deep .el-input
    width: 190px !important
  ::v-deep .el-select__tags
    height: 20px !important
::v-deep .dist_input
  width:230px
  height: 28px !important
  line-height:28px !important
  > i
    top: 8px !important
.cover_ctn
  position: relative
  .cover
    position: absolute
    z-index: 1
    top: 0
    left: 0
    width: 100%
    border: 1px solid #d4d4d4
    background: #fff
.ctn
  border: 1px solid #D4D4D4
  border-radius: 4px
  line-height: 1
  height: 42px
  background: #fff
  border-bottom: 1px solid #D4D4D4
  border-left: none
  position: relative
  z-index: 2
  > .fr
    margin-top: 14px
    position: relative
    z-index: 2
    .el-icon-caret-bottom
      &.open
        transform: rotate(180deg)
    .btns
      padding: 0 10px
      border-left: 1px solid #D4D4D4
      margin-left: 20px
      span
        cursor: pointer
        margin: 0 10px
  .left_fl
    float: left
    width: calc(100% - 180px)
    overflow: hidden
    height: 40px
    position: absolute
    z-index: 2
    top: 0
    left: 0
    background: #fff
    &.open
      overflow: visible
    .items-ctn
      // height: 100%
      overflow: hidden
      position: relative
      z-index: 1
      border-left: 1px solid #D4D4D4
      .item
        height: 42px
        padding: 7px 10px
        // border-right: 1px solid #D4D4D4
        // border-bottom: 1px solid #D4D4D4
        border: 1px solid #D4D4D4
        border-left: none
        background: #fff
        float: left
        margin-top: -1px
        // position: relative
        // top: -2px
        span
          display: inline-block
          border-right: 1px solid #D4D4D4
          padding-right: 10px
        ::v-deep .el-input, ::v-deep .el-select
          width: 120px
          input
            border: none
            padding-right: 0
          .el-select__care
            // height: 12px
        ::v-deep .el-date-editor
          width: 200px
          padding: 0 10px
          border: none
          height: 20px
          input
            width: 80px
            height: 20px
            border: none
            padding-right: 0
          .el-input__icon
            display: none
          .el-range-separator
            width: 20px

</style>

<template lang="pug">
.cover_ctn
  .cover(v-if="isOpen" :style="{ height: coverH + 'px' }")
  .ctn
    .left_fl(:class="{'open': isOpen}" ref="ctn")
      .items-ctn(ref="itemCtn")
        .item(style="border-radius: 4px 0 0 4px;")
          span 订单编号
          el-input(v-model="searchOpt.orderCode" size="mini" placeholder="请输入" @keyup.enter.native="change(1)")
        .item
          span 广告名称
          el-input(v-model="searchOpt.contentName" size="mini" placeholder="请输入" @keyup.enter.native="change(1)")
        .item
          span 创建人
          el-input(size="mini" placeholder="请输入" v-model="searchOpt.creatorName" @keyup.enter.native="change(1)")
        //- .item
          span 类型
          el-select(v-model="searchOpt.screenArea" size="mini" placeholder="请选择")
            el-option(v-for="item in orderTypes" :key="item.dictItemCode" :label="item.dictItemName" :value="item.dictItemCode")
        .item
          span 订单状态
          el-select(v-model="searchOpt.orderStatus" size="mini" placeholder="请选择")
            el-option(v-for="item in statustypes" :key="item.dictItemCode" :label="item.dictItemName" :value="item.dictItemCode")
        .item
          span 合同编码
          el-input(v-model="searchOpt.contractCode" size="mini" placeholder="请输入" @keyup.enter.native="change(1)")
        .item
          span 套餐兑换码
          el-input(v-model="searchOpt.packageInfoCode" size="mini" placeholder="请输入" @keyup.enter.native="change(1)")
        .item
          span 类型
          el-select(v-model="searchOpt.contentLevel" size="mini" placeholder="请选择")
            el-option(v-for="item in contentLevelList" :key="item.dictItemCode" :label="item.dictItemName" :value="item.dictItemCode")
        .item(style="padding-top: 12px;")
          span 投放日期
          el-date-picker(
            value-format="yyyy-MM-dd"
            v-model="time1" size="mini" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          )
        .item
          span 计费方式
          el-select(v-model="searchOpt.valuationType" size="mini" placeholder="请选择")
            el-option(v-for="item in valuationTypeList" :key="item.code" :label="item.value" :value="item.code")
        .item(style="display:flex;align-items:center;" class='cityClass')
          span 城市
          el-select(v-model="searchOpt.cityCodes" size="mini" placeholder="请选择" clearable  multiple collapse-tags  filterable @visible-change="cityVisible")
            el-option(v-for="(item, i) in cityList" :key="i" :label="item.dictItemName" :value="item.dictItemCode")
    .fr
      span(v-if="showMore" style="color: #999;cursor: pointer;" @click="isOpen = !isOpen")
        i.el-icon-caret-bottom(:class="{'open': isOpen}")
        span 更多
      .fr.btns
        span(style="color: #FF3973;" @click="change(1)") 搜索
        span(@click="change('')") 重置

</template>

<script>
import { mapState } from "vuex"

export default {
  name: 'ListSearchCp',
  data () {
    return {
      isOpen: false,
      coverH: 0,
      orderTypes: [],
      orderSnTypes: [],
      statustypes: [],
      searchOpt: {
        creatorName: ''
      },
      time1: [],
      showMore: false,
      contentLevelList: [], // 方案类型
      valuationTypeList: [], // 计费方式
    }
  },
  computed: {
    ...mapState({
      adUser: s => {
        return s ? s.customer.userInfo : {}
      }
    })
  },
  watch: {
    time1 (v) {
      this.searchOpt.startDate = v && v[0] || ''
      this.searchOpt.endDate = v && v[1] || ''
    },
    isOpen (v) { // 后续优化
      if (v) {
        this.coverH = this.$refs.itemCtn.clientHeight
      }
    },
    'adUser.userName': {
      immediate: true,
      handler (v) {
        if (v && v.length) {
          this.searchOpt.creatorName = v
          this.$emit('change', { ...this.searchOpt })
        }
      }
    }
  },
  async created () {
    this.getTypes()
    this.getAllLabelLists() // 计费方式
    this.getContentLevelList() // 广告类型列表
    this.getValuationTypeList() // 计费方式
  },
  mounted () {
    this.$nextTick(() => {
      this.handleMoreShow()
      this.getCityCodesList()
      window.addEventListener('resize', this.handleMoreShow)
    })
  },
  methods: {
     // 获取城市列表
     async getCityCodesList() {
      const result = await this.fetch('config/api/v3/region/district-list?deviceCode=33554688&levelNum=3', '', 'get')
      if (result.code === 0) {
        this.cityList = result.data.map(s => {
          return {
            dictItemCode: s.districtCode,
            dictItemName: s.districtValue
          }
        })
      } else {
        this.cityList = []
      }

    },
    getAddressCodes(data, initData) {
      if (initData) {
        this.searchOpt.cityCodes = initData
        return
      }
      this.searchOpt.cityCodes = data.map(s => s.code)
    },
    async getAllLabelLists () { // 获取所有的label数据，取其中的收费方式供计费方式列表使用
      if (!this.$store.state.label.list.length) await this.$store.dispatch('label/getSearchLabels')
    },
    reset () {
      this.searchOpt = {}
      this.time1 = []
      this.isOpen = false
      this.$emit('change', {}, true)
    },
    handleMoreShow () { // 父级组件展示的时候须调用此方法正确的更新状态
      if (this.$refs.itemCtn && this.$refs.itemCtn.clientHeight > 50) this.showMore = true
      else this.showMore = false
    },
    change (type) {
      this.isOpen = false
      if (!type) {
        this.time1 = []
        this.searchOpt = {}

        this.$emit('change', {}, true)
      } else {
        this.$emit('change', { ...this.searchOpt })
      }
    },
    async getContentLevelList () {
      let data = this.$store.state.common.CONTENTPLAYTYPE
      if (!data || data.length == 0) {
        const list = await this.$store.dispatch('getContentPlayType')
        this.contentLevelList = list
      } else {
        this.contentLevelList = data
      }
    },
    async getValuationTypeList () {
      let data = this.$store.state.common['GGDICT1080']
      if(!data || data.length == 0) await this.$store.dispatch('getDictListV2', '1080')
      let list = this.$store.state.common['GGDICT1080']
      if (typeof list == 'string') list = JSON.parse(list)
      this.valuationTypeList = list
    },
    async getTypes() {
      let load = this.$loading()
      let res = await this.fetch('/boss/common/config/v2/getOrderStatusTab', '', 'get')
      load.close()
      if (res && res.code === 0) {
        let data = (res.data || []).filter(el => {
          return el.dictItemCode == 3 || el.dictItemCode == 4
        })
        if (data.length)  this.statustypes = [{ dictItemName: '全部', dictItemCode: '3,4' }].concat(data)
      }
      let typeArr = this.$store.state.common.orderTypes
      if (!typeArr.length) {
        let load = this.$loading()
        await this.$store.dispatch('getDictItemListFromUrl', { key: 'orderTypes', url: '/boss/common/config/v2/getOrderScreenArea' })
        load.close()
        typeArr = this.$store.state.common.orderTypes
      }
      if (typeArr.length) this.orderTypes = [{ dictItemName: '全部', dictItemCode: '' }].concat(typeArr)
    }
  }
}
</script>
